module.exports = {"Open Die":"Open Die","Closed Die":"Closed Die","EDMtool Die":"EDMtool Die","Rolled Ring":"Rolled Ring","Impression Die":"Impression Die","Cold Forging":"Cold Forging","Upset Forging":"Upset Forging","Cold Warm":"Cold Warm","Mechanical Power":"Mechanical Power","Ship Boat Shipshaft":"Ship Boat Shipshaft"}


//////////////////
// WEBPACK FOOTER
// ./src/config/forgingProcess.json
// module id = 5684
// module chunks = 1